<template>
  <div class="">
    <!-- Header and Add Button -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
      <div>
        <h2 class="text-xl font-semibold text-gray-800">List of payments</h2>
      </div>
    </div>
    <!--  Search and Sort Controls -->
    <div class="flex md:flex-col items-end justify-end flex-wrap">
      <div class="flex gap-1 flex-wrap">
        <vs-select :color="colorx" v-model="search.month" @change="fetchAllPayments()" class="w-32">
          <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in months" />
        </vs-select>
        <vs-select :color="colorx" v-model="search.year" @change="fetchAllPayments()" class="w-24">
          <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in years" />
        </vs-select>
        <vs-select v-model="search.language" @change="fetchAllPayments()" class="w-28" :color="'#6366f1'">
          <vs-select-item value="all" text="Language" disabled />
          <vs-select-item v-for="lang in languages" :key="lang.culture" :value="lang.culture" :text="lang.culture" />
        </vs-select>
        <vs-select :color="colorx" @change="filter($event, 'searchKey')" v-model="search.searchKey" class="w-36">
          <vs-select-item value="" text="Search On" />
          <vs-select-item value="user_id" text="UserID" />
          <vs-select-item value="phone" text="Mobile" />
          <vs-select-item value="email" text="Email" />
          <vs-select-item value="plan_id" text="PlanID" />
          <vs-select-item value="app_type" text="App Type" />
          <vs-select-item value="device_type" text="Device Type" />
          <vs-select-item value="purchase_type" text="Purchase Type" />
          <vs-select-item value="price" text="Price" />
        </vs-select>
        <input v-model="search.searchValue" class="w-72 px-2 rounded-md" />
        <button
          @click="fetchAllPayments(search)"
          class="flex items-center gap-1 bg-blue-500 hover:bg-blue-600 text-left text-white px-4 py-2 rounded-lg font-medium transition"
        >
          <span class="material-icons text-base">search</span> Search
        </button>

        <button
          @click="resetData()"
          class="flex items-center gap-1 bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg font-medium transition"
        >
          <span class="material-icons text-base">refresh</span> Reset
        </button>
      </div>
    </div>
    <!-- graph -->
    <div class="flex flex-col">
      <div id="chart">
        <apexchart type="area" ref="chart" height="450" width="700" :options="chartOptions" :series="series"></apexchart>
      </div>
      <div class="flex gap-4 text-center justify-center">
        <p>
          In App :
          {{ this.$data.series[0].data.reduce((acc, current) => acc + current, 0) }}
        </p>
        <p>
          Subscription :
          {{ this.$data.series[1].data.reduce((acc, current) => acc + current, 0) }}
        </p>
        <p>
          Total :
          {{
            this.$data.series[0].data.reduce((acc, current) => acc + current, 0) +
            this.$data.series[1].data.reduce((acc, current) => acc + current, 0)
          }}
        </p>
      </div>
    </div>

    <!-- Payments Table -->
    <div class="overflow-x-auto rounded-xl border border-gray-200 bg-white pb-2">
      <table class="min-w-full bg-white rounded-xl">
        <thead class="border-b">
          <tr>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">#</th>
            <th class="px-4 py-3 text-xs text-start font-semibold text-gray-500 uppercase">UserID/Email/Mobile</th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Language</th>
            <th class="px-4 py-3 text-xs text-start font-semibold text-gray-500 uppercase">PlanID/App Type</th>
            <th class="px-4 py-3 text-xs text-start font-semibold text-gray-500 uppercase">Device Type</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Purchase Type/Price</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Purchase Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(payment, idx) in all" :key="payment._id" class="border-b hover:bg-gray-100 transition">
            <td class="px-4 py-1">{{ idx + 1 + (current_page - 1) * data_per_page }}</td>
            <td class="px-4 py-1 font-medium text-gray-800 truncate">
              {{ renderUserInfo(payment) }}
            </td>
            <td class="px-4 py-1 font-medium text-gray-800">
              {{ payment.language }}
            </td>
            <td class="px-4 py-1 font-medium text-gray-800">
              Plan ID: {{ payment.plan_id }}
              <br />
              App Type: {{ payment.app_type }}
            </td>
            <td class="px-4 py-1 font-medium text-gray-800">
              {{ payment.device_type }}
            </td>
            <td class="px-4 py-1 font-medium text-gray-800">
              Type: {{ payment.purchase_type }}
              <br />
              Price: {{ payment.price }}
            </td>
            <td class="px-4 py-1 font-medium text-gray-800">
              {{ moment(payment.date) }}
            </td>
          </tr>
          <tr v-if="!all || all.length === 0">
            <td colspan="12" class="text-center h-full py-6 text-gray-400">No payment data found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Pagination -->
    <div class="flex flex-col md:flex-row items-center justify-between mt-3 pr-3">
      <div class="invisible">
        <span>asd</span>
      </div>
      <div class="flex justify-center items-center">
        <vs-pagination :total="page_count" v-model="current_page" :max="maxVisiblePages" :prev-text="'Prev'" :next-text="'Next'" />
      </div>
      <div class="flex items-center gap-2 text-sm mt-2 md:mt-0">
        <span>Show Records:</span>
        <vs-select v-model="data_per_page" @change="fetchAllPayments()" class="w-20" :color="'#6366f1'">
          <vs-select-item value="25" text="25" />
          <vs-select-item value="50" text="50" />
        </vs-select>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import moment from "moment";

export default {
  name: "Payments",
  components: {},
  data: () => ({
    title: "Payments",
    colorx: "#0D2144",
    wordBreak: "break-all",
    sortByField: "",
    sortDirection: "asc",
    defaultalert: false,
    isNew: true,
    search: {
      language: "all",
      searchKey: "",
      searchValue: "",
      month: "",
      year: "",
    },
    months: [
      { value: 1, text: "January" },
      { value: 2, text: "February" },
      { value: 3, text: "March" },
      { value: 4, text: "April" },
      { value: 5, text: "May" },
      { value: 6, text: "June" },
      { value: 7, text: "July" },
      { value: 8, text: "August" },
      { value: 9, text: "September" },
      { value: 10, text: "October" },
      { value: 11, text: "November" },
      { value: 12, text: "December" },
    ],
    years: [],
    all: [],
    totalDates: [],
    languages: [],
    series: [
      {
        name: "in_app",
        data: [],
      },
      {
        name: "subscription",
        data: [],
      },
    ],
    chartOptions: {
      chart: {
        height: 250,
        type: "area",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      xaxis: {
        type: "datetime",
        categories: [],
      },
      tooltip: {
        x: {
          format: "dd/MM/yy",
        },
      },
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    total_data: 0,
    data_per_page: 25,
    page_count: 0,
    total_pages_array: [],
    current_page: 1,
    maxVisiblePages: 7,
  }),
  methods: {
    renderUserInfo(payment) {
      // if its bigger 30 characters, truncate it
      let userInfo = payment.user_id || payment.email || payment.phone;
      if (userInfo && userInfo.length > 30) {
        return userInfo.substring(0, 27) + "..." || "N/A";
      }

      return userInfo || "N/A";
    },

    moment: function (date) {
      return moment.utc(date).format("DD/MM/YYYY");
    },
    sortByDate(field) {
      if (this.sortByField === field) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortByField = field;
        this.sortDirection = "asc";
      }
      this.all = this.sortedData;
    },

    async fetchAllPayments(search = false) {
      if (search) {
        if (this.$data.search.searchKey.length === 0) {
          this.$vs.notify({
            title: "Error",
            text: "Please select a field to search",
            color: "danger",
            position: "top-right",
          });
          return;
        }

        if (this.$data.search.searchValue.length === 0) {
          this.$vs.notify({
            title: "Error",
            text: "Please enter a value to search",
            color: "danger",
            position: "top-right",
          });
          return;
        }
      }

      try {
        this.$vs.loading();

        const r = await api.get(API.GET_PAYMENTS, {
          params: {
            page: this.current_page,
            size: this.data_per_page,
            language: this.$data.search.language,
            searchKey: this.$data.search.searchKey,
            searchValue: this.$data.search.searchValue,
            graphMonth: this.$data.search.month,
            graphYear: this.$data.search.year,
          },
        });

        r.data.allPayments.sort((a, b) => {
          return new Date(b.date) - new Date(a.date);
        });

        this.$data.all = r.data.allPayments;

        this.$data.total_data = r.data.totalCount;
        this.$data.page_count = Math.ceil(r.data.totalCount / this.$data.data_per_page);
        this.$data.total_pages_array = [...Array(this.$data.page_count).keys()];

        this.setGraphData(r.data.graphData);
        this.$refs.chart.refresh();
        // this.setGraphDate();
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Could not find the data",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
        // this.setGraphDate();
      }
    },

    // setGraphDate() {
    //   this.$data.chartOptions.xaxis.categories = [];
    //   var date1 = new Date(this.$data.startDate);
    //   var date2 = new Date(this.$data.endDate);

    //   var differenceInTime = date2.getTime() - date1.getTime();
    //   var differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));

    //   for (var i = 0; i < differenceInDays + 1; i++) {
    //     const d = moment(date1).add(i, "day");
    //     this.$data.chartOptions.xaxis.categories.push(moment.utc(d).format("YYYY-MM-DD"));
    //   }
    // },

    setGraphData(paymentData) {
      this.series[0].data = [];
      this.series[1].data = [];

      const groupedByDate = {};

      paymentData.forEach((payment) => {
        const dateKey = moment(payment.date).format("YYYY-MM-DD");

        if (!groupedByDate[dateKey]) groupedByDate[dateKey] = { in_app: 0, subscription: 0 };
        if (payment.purchase_type === "in_app") groupedByDate[dateKey].in_app += Number(payment.price);
        if (payment.purchase_type === "subscription") groupedByDate[dateKey].subscription += Number(payment.price);
      });

      const categories = Object.keys(groupedByDate).sort();

      this.chartOptions = {
        ...this.chartOptions,
        xaxis: {
          ...this.chartOptions.xaxis,
          categories,
        },
      };

      categories.forEach((date) => {
        const day = groupedByDate[date];
        this.series[0].data.push(day.in_app);
        this.series[1].data.push(day.subscription);
      });

      this.$refs.chart.refresh();
    },

    // handleCurrentPage(page) {
    //   this.$data.current_page = page;
    //   this.fetchAllPayments();
    // },

    // handlePrevPage() {
    //   if (this.current_page > 0) {
    //     this.handleCurrentPage(this.current_page - 1);
    //   }
    // },

    // handleNextPage() {
    //   if (this.current_page < this.page_count - 1) {
    //     this.handleCurrentPage(this.current_page + 1);
    //   }
    // },

    async fetchAllLanguages() {
      this.$vs.loading();
      try {
        const r = await api.get(API.GET_LANG, {});
        this.languages = r.data;
      } catch (error) {
        this.$vs.notify({
          text: "Error fetching languages",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    filter(event, param = true) {
      this.$data.search[param] = event;
    },

    resetData() {
      this.$data.search = {
        language: "all",
        searchKey: "",
        searchValue: "",
      };
      this.current_page = 1;
      this.page_count = 1;
      this.$data.search.month = moment().format("M");
      this.$data.search.year = moment().format("YYYY");
      this.fetchAllPayments();
    },

    generateYears() {
      const currentYear = moment().year();
      for (let year = 2021; year <= currentYear; year++) {
        this.years.push(year);
      }
    },
  },
  async created() {
    this.generateYears();

    this.$data.search.month = moment().month() + 1;
    this.$data.search.year = moment().year();
    await Promise.allSettled([this.fetchAllPayments(), this.fetchAllLanguages()]);
    if (!this.$data.search.language) this.$data.search.language = "all";
  },
};
</script>

<style scoped>
.material-icons {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}
</style>
